import { render, staticRenderFns } from "./edit-Imagen-participacion.vue?vue&type=template&id=5ed0c662&scoped=true"
import script from "./edit-Imagen-participacion.vue?vue&type=script&lang=ts"
export * from "./edit-Imagen-participacion.vue?vue&type=script&lang=ts"
import style0 from "./edit-Imagen-participacion.vue?vue&type=style&index=0&id=5ed0c662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed0c662",
  null
  
)

export default component.exports